import React, { Component } from "react";
import { Parse } from "parse";
import styled from "styled-components";
import {
  Button,
  DatePicker,
  Form,
  Modal,
  message,
  Select,
  TimePicker,
  Row
} from "antd";

import "moment/locale/fr";
import "./calendar.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "../App.css";

const moment = require("moment-timezone");

const FormItem = Form.Item;
const Option = Select.Option;

const Modalstyled = styled(Modal)`
  .ant-modal-content {
    width: 600px;
  }
`;

class ClientModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: this.props.visible
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.visible !== this.state.visible) {
      this.setState({ visible: this.props.visible });
    }
  }

  disabledDate = current => {
    var a = moment().subtract(1, "day");
    // Can not select days before today and today
    return current && current < a;
  };

  handleCancel = e => {
    this.props.handleCancel();
    this.props.form.resetFields(["startHour", "startDate", "endHour"]);
  };

  //OnChange //
  onChangeEventType = e => {

    if (!e) return;

    this.props.setEventTypeChild(e);
    this.props.form.setFieldsValue({ eventType: e });
  };

  disabledTime() {
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23
    //9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
    var arrayHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 22, 23];
    return arrayHours;
  }
  disabledDate = current => {
    var a = moment().subtract(1, "day");
    // Can not select days before today and today
    return current && current < a;
  };

  /*on choisit quels types d'event seront affichés si l'utilisateur est un pro ou pas, si c'est la semaine test -> à faire*/
  displayEventType() {
    return (
      <Select onChange={this.onChangeEventType}>
        <Option value="Cours en groupe">
          Réserver un créneau de cours en groupe
        </Option>
        <Option value="Cours individuel">Demande de cours individuel</Option>
        <Option value="RDV diet">Demande de rendez-vous diet</Option>
      </Select>
    );
  }

  handleSubmit = e => {
    let user = Parse.User.current();
    let expiAbo = user.attributes.expirationAbo;
    let now = new Date();

    e.preventDefault();
    if (now < expiAbo && expiAbo) {
      this.props.form.validateFields((error, values) => {
        if (error) {
          message.error("Certains champs ne sont pas correctement remplis");
        } else if (
          this.state.eventType === "Cours en groupe" &&
          this.state.startHour.localeCompare("19:30") >= 0
        ) {
          this.props.form.resetFields(["startHour", "endHour"]);
          message.error(
            "Vous ne pouvez pas créer un cours en groupe après 19h."
          );
        } else if (
          this.state.eventType === "Cours en groupe" &&
          this.state.startHour.localeCompare("09:00") <= -1
        ) {
          this.props.form.resetFields(["startHour", "endHour"]);
          message.error(
            "Vous ne pouvez pas créer un cours en groupe avant 9h."
          );
        } else {
          this.props.saveNewEvent(values);
        }
      });
    } else {
      this.handleCancel();
      message.error(
        "Votre abonnement a expiré ! Vous devez vous réinscrire pour participer aux cours. "
      );
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };

    const dateFormat = "DD/MM/YYYY";
    const dateConfig = {
      rules: [
        {
          type: "object",
          required: true,
          message: "Merci d'indiquer la date"
        }
      ],
      initialValue: moment(this.props.startDate)
    };
    const format = "HH:mm";

    return (
      <Modalstyled
        title="Créer un cours"
        visible={this.state.visible}
        onCancel={this.handleCancel}
        onOk={this.props.handleOk}
        footer={null}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Type du cours">
            {getFieldDecorator("eventType", {
              rules: [
                {
                  required: true,
                  message: "Veuillez spécifier le type de cours"
                }
              ],
              initialValue: "Cours en groupe",
              onChange: this.onChangeEventType
            })(this.displayEventType())}
          </FormItem>
          <FormItem {...formItemLayout} label="Date du cours">
            {getFieldDecorator("startDate", dateConfig)(
              <DatePicker
                disabledDate={this.disabledDate}
                style={{ width: 200 }}
                format={dateFormat}
              />
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="Heure de début">
            {getFieldDecorator("startHour", {
              rules: [
                {
                  required: true,
                  message: "Merci d'indiquer une heure de début"
                }
              ],
              initialValue: moment(this.props.startDate, format)
            })(
              <TimePicker
                format="HH:mm"
                disabledHours={this.disabledTime}
                minuteStep={15}
                clearText="Supprimer"
                placeholder="Heure"
                onChange={this.props.onChangeStartHour}
              />
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="Heure de fin">
            {getFieldDecorator("endHour", {
              rules: [
                {
                  required: false,
                  message: "Merci d'indiquer une heure de fin"
                }
              ],
              initialValue: moment(this.props.endHour, format)
            })(<TimePicker format="HH:mm" minuteStep={15} disabled={true} />)}
          </FormItem>
          <FormItem>
            <Row type="flex" justify="center">
              <Button type="primary" htmlType="submit">
                Créer
              </Button>
            </Row>
          </FormItem>
        </Form>
      </Modalstyled>
    );
  }
}
const connectedClientCalendar = Form.create()(ClientModal);
export default connectedClientCalendar;
